import { useTheme } from "@emotion/react";
import React from "react";

import { Button, Header, Icon, Text } from "~/components/blocks";

type Props = {
  title: string;
  backText?: string;
  onBack?: () => void;
};

export const AppHeader: React.VFC<Props> = (props) => {
  const theme = useTheme();

  return (
    <Header
      attached
      action={
        props.onBack && (
          <Button size="m" use="white" weight="thin" onClick={props.onBack}>
            <Icon icon="arrow-left" size="l" />
            {props.backText || "戻る"}
          </Button>
        )
      }
      paddingY={theme.space.l}
    >
      <Text size="m">{props.title}</Text>
    </Header>
  );
};
